/**
 * Repairs malformed Shopify CDN image URLs produced by the Revie reviews app.
 *
 * The app builds review thumbnails by appending a second query string onto a
 * URL that already has one:
 *
 *   ...IMG_0793.jpg?v=1746634093&width=150?width=450&quality=90
 *                                 ^^^^^^^^^^^^^^^^^^^^^^^^^^^^
 *                                 width = "150?width=450"  (not an integer)
 *
 * Shopify's CDN cannot parse that width, silently skips resizing, and serves
 * the ORIGINAL image - measured on the live product page: a 1878x1878 file
 * (508 KiB) delivered for a thumbnail displayed at 75x75. Across the review
 * list this wastes roughly 1.9 MB, more than half the page's total weight.
 *
 * Truncating at the second "?" leaves the app's own first width value intact
 * and produces a URL the CDN can actually honour:
 *
 *   ...IMG_0793.jpg?v=1746634093&width=150
 *
 * Runs as a MutationObserver so URLs are corrected at insertion time, before
 * the browser starts fetching them (the app's images are loading="lazy", so
 * there is comfortable headroom). Rewrites are no-ops when a URL is already
 * well-formed, which also keeps the attribute observer from looping.
 */
(function () {
  var CDN_HOST = 'cdn.shopify.com';
  var ATTRS = ['src', 'data-src'];

  // A well-formed URL has at most one "?"; a second one is the app's bug.
  function normalizeUrl(url) {
    var first = url.indexOf('?');
    if (first === -1) return url;

    var second = url.indexOf('?', first + 1);
    if (second === -1) return url;

    return url.slice(0, second);
  }

  function fixImage(img) {
    for (var i = 0; i < ATTRS.length; i++) {
      var attr = ATTRS[i];
      var value = img.getAttribute(attr);
      if (!value || value.indexOf(CDN_HOST) === -1) continue;

      var fixed = normalizeUrl(value);
      if (fixed !== value) img.setAttribute(attr, fixed);
    }
  }

  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.tagName === 'IMG') fixImage(node);
    if (!node.querySelectorAll) return;

    var images = node.querySelectorAll('img');
    for (var i = 0; i < images.length; i++) fixImage(images[i]);
  }

  scan(document.documentElement);

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];

      for (var j = 0; j < mutation.addedNodes.length; j++) {
        scan(mutation.addedNodes[j]);
      }

      if (mutation.type === 'attributes' && mutation.target.tagName === 'IMG') {
        fixImage(mutation.target);
      }
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ATTRS,
  });
})();
